import { ParameterMetadata, ParameterType, PrimitiveType } from '../../../api/api';
import { GenericProperties } from '../../FlowDesigner/ActionPanel/GenericProperties';
import { EmbeddedResourceModel } from '../Models/EmbeddedResourceModel';

const parameters: ParameterMetadata[] = [
	{
		name: 'Name',
		displayName: 'Name',
		type: ParameterType.Primitive,
		categories: [],
		isCollection: false,
		expectedType: { type: PrimitiveType.String },
		order: 0,
	},
];

type EmbeddedResourcePropertiesProps = {
	resource: EmbeddedResourceModel;
	onResourceChanged: (resource: EmbeddedResourceModel) => void;
};

export function EmbeddedResourceProperties({ resource, onResourceChanged }: EmbeddedResourcePropertiesProps) {
	return <GenericProperties<EmbeddedResourceModel> parameters={parameters} model={resource} id={resource.Id} onModelChanged={onResourceChanged} />;
}
